export enum Language {
  English = 'EN',
  French = 'FR',
}
